// ComingSoonModal.jsx - Lightweight modal for features not yet implemented
import React from "react";

/**
 * ComingSoonModal
 * Props:
 *   message {string} - Text to display
 *   onClose {Function} - Called when dismissed
 */
function ComingSoonModal({ message, onClose }) {
  if (!message) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={message}
      onClick={onClose}
      className="safe-area-overlay"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.45)",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "var(--bg-primary, #fff)",
          borderRadius: "12px",
          padding: "2rem 2.5rem",
          maxWidth: "360px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
          border: "1px solid var(--border-color, #ddd)",
        }}
      >
        <p style={{
          margin: "0 0 1.5rem 0",
          fontSize: "1.05rem",
          fontWeight: 500,
          color: "var(--text-primary, #333)",
          lineHeight: 1.5,
        }}>
          {message}
        </p>
        <button
          onClick={onClose}
          style={{
            padding: "0.5rem 1.5rem",
            background: "var(--pista-green-primary, #2E7D32)",
            color: "var(--pista-button-text, #fff)",
            border: "none",
            borderRadius: "6px",
            fontSize: "0.9rem",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Got it
        </button>
      </div>
    </div>
  );
}

export default ComingSoonModal;
